<template>
  <v-sheet>
    <div class="border">
      <div class="inner-border">Items</div>
      <base-grid
        :items="learningItems"
        :imageUrls="imageUrls"
        v-on:grid:badge:click="
          $router.push({
            name: 'learningItemMember',
            params: { id: $event.id }
          })
        "
        gridId="js-learning-items-grid"
      />
    </div>
  </v-sheet>
</template>
<script>
import eventMixin from "@/mixins/eventMixin"
import BaseGrid from "@/components/BaseGrid"

export default {
  mixins: [eventMixin],
  components: {
    BaseGrid
  },
  props: {
    courseId: { type: Number }
  },
  computed: {
    learningItems() {
      let course = this.$store.getters["courses/getCourseById"](this.courseId)
      return course ? course.learning_items : []
    },
    imageUrls() {
      return this.learningItems.map(el => el.badge_url)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../scss/variables";
div.border {
  border: solid;
  border-width: 1px;
  color: $light-grey;
  min-height: 170px;
}
div.inner-border {
  border-bottom: solid;
  border-width: 1px;
  color: $light-grey;
  font-size: 0.8em;
  font-style: italic;
  padding-left: 8px;
  text-transform: uppercase;
}
</style>
